import React from 'react';
import styled from '@emotion/styled';


/* styles taken from site-footer, and footer__legal-link */
const Link = styled.a`
    color: #4632d8;
    transition: color .2s;
    text-decoration: underline;
    cursor: pointer;
    font-family: var(--bs-body-font-family);
    font-weight: var(--bs-body-font-weight);
    line-height: var(--bs-body-line-height);
`;

const TAndCUrl = 'https://www.simplybusiness.co.uk/terms-conditions/';
const PrivacyPolicyUrl = 'https://www.simplybusiness.co.uk/privacy-policy/';
const CookiePolicyUrl = 'https://www.simplybusiness.co.uk/legal/cookies/';
const AccessibilityUrl = 'https://www.simplybusiness.co.uk/support/accessibility/';

const USContactInfoContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 16px;
    row-gap: 32px;
    padding-top: 1.5rem;
    padding-bottom: 0.75rem;
    -webkit-font-smoothing: antialiased;

    @media (max-width: 959px) {
        grid-template-columns: 1fr;
        column-gap: 0;
    }
`;

const UsContactInfoAddress = styled.div`
    grid-column: 2;
    display: flex;
    flex-direction: column;

    @media (max-width: 959px) {
        grid-column: 1;
    }
`;

const UsContactInfoLinks = styled.div`
    grid-column: 3;
    display: flex;
    flex-direction: column;

    @media (max-width: 959px) {
        grid-column: 1;
    }
`;


const BodyText = styled.p`
    font-family: var(--bs-body-font-family);
    font-weight: var(--bs-body-font-weight);
    font-size: var(--font-size-small-paragraph);
    line-height: 1.2857142857;
    color: var(--color-text-medium);
    margin: 0;
`;

const HeadingText = styled.p`
    line-height: 1.3;
    font-size: var(--font-size-small-paragraph);
    font-weight: bold;
    color: black;
    margin: 0 0 0.5rem 0;
`;


const USContactInfo = (): React.JSX.Element => (
  <USContactInfoContainer data-testid={'us-contact-info'}>
    <UsContactInfoAddress>
      <HeadingText>Address</HeadingText>
      <BodyText>Simply Business</BodyText>
      <BodyText>53 State Street, 19th Floor</BodyText>
      <BodyText>Boston, MA</BodyText>
      <BodyText>02109</BodyText>
    </UsContactInfoAddress>
    <UsContactInfoLinks>
      <HeadingText>Legal</HeadingText>
      <BodyText>
        <Link href={TAndCUrl} target={'_blank'}>Terms & conditions</Link>
      </BodyText>
      <BodyText>
        <Link href={PrivacyPolicyUrl} target={'_blank'}>Privacy policy</Link>
      </BodyText>
      <BodyText>
        <Link href={CookiePolicyUrl} target={'_blank'}>Cookie policy</Link>
      </BodyText>
      <BodyText>
        <Link href={AccessibilityUrl} target={'_blank'}>Accessibility</Link>
      </BodyText>
    </UsContactInfoLinks>
  </USContactInfoContainer>
);

export default USContactInfo;
